import React, { useCallback, useEffect, useState } from 'react'
import { DetalleGrupoActividadHEDTO, DetalleRegimenLaboralHEDTO, DetalleServidoresPlanificacionHE, NovedadesServidoresHEDTO, ParamsHorasMesPlanificacionHEDTO } from "./TypesPlanificacionHE"
import { InformacionBusquedaUsuario, SelectCombo } from 'components/Types/GeneralTypes'

import { Container, FormGroup } from 'react-bootstrap'
import { Row, Col, Form, Input, Label, Button } from "reactstrap"
import FindAsyncSelect from 'components/Varios/SelectsComponent/FindAsyncSelect'
import { showAlert } from 'components/Admin/Horas Extras/Parametros Horas Extras/Actividades/ActividadesHorasExtras'
import { BuscarInformacionPersonaByIdentificacion, BuscarInformacionPersonaByNombreApellido } from '../ProyeccionHE/FunctionsProyeccionDirectivoUnidad'
import { ObtenerInformacionServidorHE } from './FunctionsPlanificacionHE'
import ModalCargando from 'components/Varios/ModalCargando'
import TableServidoresPlanHE from './TableServidoresPlanHE'

type PropsTabOtrasUnidadesPlan = {
    idUnidadAprueba: number,
    novedadesServidores: NovedadesServidoresHEDTO[]
    mensajeNovedad: string,
    estadoPlanificacion: string,
    listadoServidoresOtrasUnidades: DetalleServidoresPlanificacionHE[],
    paramsHorasMesPlanificacionHE:ParamsHorasMesPlanificacionHEDTO[]
    recargarInformacion: () => Promise<void>
    regimenLaboralesPlan:DetalleRegimenLaboralHEDTO[];
    puedeRealizarAccion?: boolean;
    guardarParcial: () => void
    firmaryEnviar: () => Promise<void>
    solicitarReverso: () => void
    descargarResumenExcel: () => Promise<void>
    mostrarGuardarParcial?: boolean | undefined;
    mostrarFirmaryEnviar?: boolean | undefined;
    mostrarSolicitarReverso?: boolean | undefined;
    mostrarReporteResumenProyPlanifExcel?: boolean | undefined;
    loadingAccionReporteExcel: boolean
    nombreUnidadAprueba?: string,
    gruposActividad: DetalleGrupoActividadHEDTO[];
    docPlanificacionUnidad?: string;
    idPlanificacionUnidad?: number;
}

export default function TabOtrasUnidadesPlan(props: PropsTabOtrasUnidadesPlan) {

    const [identificacion, setidentificacion] = useState<string>("")
    const [nombresSeleccionado, setnombresSeleccionado] = useState<SelectCombo | undefined | null>()
    const [loadingidentificacion, setloadingidentificacion] = useState<boolean>(false)
    const [informacionTabla, setinformacionTabla] = useState<DetalleServidoresPlanificacionHE[]>(props.listadoServidoresOtrasUnidades)
    const [buscandoinfoservidorhe, setbuscandoinfoservidorhe] = useState<boolean>(false)

    useEffect(() => {
        setinformacionTabla(props.listadoServidoresOtrasUnidades)
    }, [props.listadoServidoresOtrasUnidades])

    function MapearInformacionUsuario(info: InformacionBusquedaUsuario) {
        const informacionMapeada: SelectCombo = {

            label: info.apellidos + " " + info.nombres,
            value: info.idpersona.toString() + "|" + info.identificacion + "|" + info.apellidos + "|" + info.nombres
        }
        return informacionMapeada
    }


    async function ObtenerInformacionByCedula(identificacion: string) {
        if (identificacion.length === 10) {
            setidentificacion(identificacion)
            setloadingidentificacion(true)
            const respuesta = await BuscarInformacionPersonaByIdentificacion(identificacion)
            if (respuesta.status === 200 && respuesta.dataResponse) {

                const v = respuesta.dataResponse;
                const informacionMapeada: SelectCombo = MapearInformacionUsuario(v);
                setnombresSeleccionado(informacionMapeada);
            }
            else {
                showAlert("No se ha encontrado información con la identificación indicada", false);
            }
            setloadingidentificacion(false)
        }
        else if (identificacion.length < 10 && identificacion.length >= 0) {
            setidentificacion(identificacion)
        }
        else {
            showAlert("Solo puede ingresar 10 dígitos", false);
        }
    }

    async function ObtenerInformacionByNombreApellido(nombreapellido: string) {
        const respuesta = await BuscarInformacionPersonaByNombreApellido(nombreapellido)
        if (respuesta.status === 200 && respuesta.dataResponse && respuesta.dataResponse.length > 0) {
            const informacionMapeada: SelectCombo[] = respuesta.dataResponse.map((v, i) => {
                return MapearInformacionUsuario(v)
            })
            return informacionMapeada
        }
        else if (respuesta.status === 204) {
            return []
        }
        else {
            return []
        }
    }

    function OnChangeSelectApellidoNombre(seleccionado: SelectCombo | undefined) {
        if (seleccionado) {
            const informacionDivision = seleccionado?.value.split("|")
            const idpersona: number = +informacionDivision[0]
            const identific: string = informacionDivision[1]
            setidentificacion(identific)
            setnombresSeleccionado(seleccionado)
        }
        else {
            setnombresSeleccionado(seleccionado)
        }

    }

    const OnClickAgregar = useCallback(async (seleccionado: SelectCombo | undefined | null) => {
        if (seleccionado) {

            const informacionDivision = seleccionado.value.split("|")
            const identific: string = informacionDivision[1]

            const personaExistente = informacionTabla.find((v => v.identificacion === identific));

            if (informacionTabla.length === 0 || (informacionTabla.length > 0 && personaExistente === undefined)) {
                
                setbuscandoinfoservidorhe(true)
                const respuestaInformacionServidor = await ObtenerInformacionServidorHE(identific);

                if (respuestaInformacionServidor.status === 200 && respuestaInformacionServidor.dataResponse) {
                    // const informacionServidor: InformacionServidoresOtrasUnidadesHEDTO = respuestaInformacionServidor.dataResponse;
                    // const nuevoRegistroTabla = CrearInformacionParaTabla(informacionServidor)

                    const informacionServidor = respuestaInformacionServidor.dataResponse;

                    if(informacionServidor.tipo && informacionServidor.tipo !== "SR"){
                        showAlert("El servidor escogido no puede ser planificado.", false);
                        
                    }
                    else {
                        const nuevaInfoTabla = [...informacionTabla, informacionServidor]
                        setinformacionTabla(nuevaInfoTabla)
                    }

                    
                }
                else {
                    const messagedefault = "Ha ocurrido un inconveniente al intentar obtener información del usuario"
                    showAlert(respuestaInformacionServidor.errorMessage ?? messagedefault, false);
                }

                setbuscandoinfoservidorhe(false)

            }
            else {
                showAlert("La persona indicada ya se encuentra planificada", false)
            }
        }
        setidentificacion("")
        setnombresSeleccionado(null)

    }, [informacionTabla])
    
    return (
        <React.Fragment>
            {props.puedeRealizarAccion && (
            <Form>
                <Container fluid={true}>
                    <Row className="mb-2">
                        <Col className="bold" >
                        
                            {"(Para planificar servidores de otras unidades que realicen horas extras en su unidad)"}
                        </Col>
                    </Row>
                </Container>
                <Row>
                    <Col md="3">
                        <FormGroup>
                            <Label>Identificacion</Label>
                            <Input
                                value={identificacion}
                                // disbled={nombres !== ""}
                                type="text"
                                name="identificacionOtraUnidad"
                                placeholder="Ingrese identificación"
                                autoComplete="off"
                                onChange={(e) => ObtenerInformacionByCedula(e.target.value)}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="5">
                        <FormGroup>
                            <Label>Apellidos/Nombres</Label>
                            <FindAsyncSelect
                                value={nombresSeleccionado}
                                icon="fa-caret-down"
                                placeholder='Ingrese Apellidos/Nombres'
                                onFind={(valor) => ObtenerInformacionByNombreApellido(valor)}
                                onChange={(valor) => OnChangeSelectApellidoNombre(valor)}
                                name="nombreApellidoOtraUnidad"
                                noOptionsMessage="Ingresa un apellido o nombre"

                            /> 
                        </FormGroup>
                    </Col>
                    <Col md="3" className="d-flex align-items-end" >
                        
                            <>
                            <Button
                                className="btn-guardar"
                                onClick={() => OnClickAgregar(nombresSeleccionado)}
                                disabled={nombresSeleccionado === undefined}
                            >
                                Agregar
                            </Button>
                            </>

                    </Col>

                </Row>
            </Form>
            )}
            { informacionTabla.length > 0 && (
                    <TableServidoresPlanHE
                        servidoresPlan={informacionTabla}
                        recargarInformacion={props.recargarInformacion}
                        paramsHorasMesPlanificacionHE={props.paramsHorasMesPlanificacionHE}
                        novedadesServidores={props.novedadesServidores}
                        estadoPlanificacion={props.estadoPlanificacion}
                        mensajeNovedad={props.mensajeNovedad}
                        tipo='PL'
                        idUnidadAprueba={props.idUnidadAprueba}
                        nombreUnidadAprueba={props.nombreUnidadAprueba}
                        regimenLaboralesPlan={props.regimenLaboralesPlan}
                        puedeRealizarAccion={props.puedeRealizarAccion}
                        guardarParcial = {props.guardarParcial}
                        firmaryEnviar = {props.firmaryEnviar}
                        solicitarReverso = {props.solicitarReverso}
                        descargarResumenExcel={props.descargarResumenExcel}
                        mostrarGuardarParcial = {props.mostrarGuardarParcial}
                        mostrarFirmaryEnviar  = {props.mostrarFirmaryEnviar}
                        mostrarSolicitarReverso = {props.mostrarSolicitarReverso}                
                        mostrarReporteResumenProyPlanifExcel = {props.mostrarReporteResumenProyPlanifExcel}
                        loadingAccionReporteExcel = {props.loadingAccionReporteExcel}
                        gruposActividad={props.gruposActividad}
                        docPlanificacionUnidad={props.docPlanificacionUnidad}
                        idPlanificacionUnidad={props.idPlanificacionUnidad}
                    />
                )
            }

            <ModalCargando
                show={loadingidentificacion}
                textoCargando='Buscando información...'
                size='md'
                onClose={() => setloadingidentificacion(false)}
            />
            <ModalCargando
                show={buscandoinfoservidorhe}
                textoCargando='Buscando información...'
                size='md'
                onClose={() => setbuscandoinfoservidorhe(false)}
            />
        </React.Fragment>
        
    )
}